import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { LogoutService } from '../user-repository/logout.service';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private userRefreshTokenService: UserRefreshTokenService,
    private logoutService: LogoutService
  ) {}
  async handleError(exp: HttpErrorResponse) {
    const body = {
      error: JSON.stringify(exp.error),
      headers: JSON.stringify(exp.headers),
      message: exp.message,
      name: exp.name,
      ok: exp.ok,
      status: exp.status,
      statusText: exp.statusText,
      type: exp.type,
      url: exp.url,
    };

    const data: any = {
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'no-cors',
      method: 'POST',
      body: JSON.stringify(body),
    };
    await fetch('https://dev.bentoapp.org/api/v2/discord', data);
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        console.log('error is intercept');
        console.error(error);
        this.handleError(error);
        if (error.status === 403 || error.status === 401) {
          this.userRefreshTokenService.refreshToken().then((res) => {
            if (res.isSuccess()) {
              req.clone();
            }
            if (!res.isSuccess()) {
              this.logoutService.logout();
            }
          });
        }
        return throwError(error.message);
      })
    );
  }
}
